import { BASE_URL, responseHandler, bearerAuthHeader } from "./helpers";

export const notiflowService = {
  fetchSendOTP,
  fetchLoginWithOTP,
};
async function fetchSendOTP(body) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
  };
  const result = await fetch(`${BASE_URL}/notiflow/SendOTP?phone=${body}`, requestOptions);

  return responseHandler(result);
}
async function fetchLoginWithOTP(body) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(await bearerAuthHeader()),
    },
    body: JSON.stringify({ ...body }),
  };
  const result = await fetch(
    `${BASE_URL}/notiflow/loginwithotp`,
    requestOptions
  );

  return responseHandler(result);
}
